module.exports = __webpack_public_path__ + "public/img/home_main2_img1@1x.58403b0b.png";